export const emptySettlement = () => ({
  survivalLimit: 0,
  deathCount: 0,
  milestoneStoryEvents: "",
  departingBonuses: "",
  innovations: "",
  settlementLocations: "",
  principles: "",
  quarries: "",
  resourceStorage: "",
  gearStorage: "",
  nemesisMonsters: "",
  lanternResearchLevel: 0,
  notes: "",
  lostSettlements: "",
  population: 0,

  collectiveCognition: 0,
  collectiveCognitionRewards: "",
  philosophies: "",
  knowledge: "",
});

export const emptyCampaign = () => ({
  id: "",
  revision: 0,
  schemaVersion: 2,
  settlementName: "",
  campaignType: "",
  monsters: [],
  pillars: [],
  survivors: [],
  departingSurvivorIds: [],
  settlement: emptySettlement(),

  // NEW: persistent timeline tracking
  // keys: "prologue", "year_1", "year_2", ...
  // value: { yearComplete, checkedEvents: { [eventText]: boolean }, foughtMonster, foughtLevel, notes }
  timelineProgress: {},

  createdAt: "",
  updatedAt: "",
});
